import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  Empty,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Pagination,
  Row,
  Switch,
  Table,
  Upload,
} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import { UploadFile } from 'antd/lib/upload/interface';
import { gql } from 'apollo-boost';
import moment from 'moment';
import React, { FC, useState } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { EnrollmentSource } from 'smartpi-core';
import { client } from 'src/services/api';
import { PageInfo } from 'src/types/base';
import { Logistics, LogisticsStasus } from 'src/types/logistics';
import { notEmpty } from 'src/utils/collections';
import * as xlsx from 'xlsx';

const COUNT_PER_PAGE = 20;
export const LogisticsList: FC = () => {
  const [visible, setVisible] = useState(false);

  const [importVisible, setImportVisible] = useState(false);

  const [logisticsId, setLogisticsId] = useState(0);
  const [company, setCompany] = useState('');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [notify, setNotify] = useState(true);

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [trackingList, setTrackingList] = useState<
    {
      logisticsId: number;
      trackingNumber: string;
      company: string;
      notify: boolean;
    }[]
  >([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [variables, setVariables] = useState<{
    mobile?: string;
    take: number;
    skip?: number;
    before?: number;
    after?: number;
  }>({
    skip: 0,
    take: COUNT_PER_PAGE,
  });

  const [mobile, setMobile] = useState('');

  const GAT_LOGISTICS = gql`
    query logisticsesConnection($take: Int, $skip: Int, $after: ID, $before: ID, $mobile: String) {
      logisticsesConnection(take: $take, skip: $skip, after: $after, before: $before, mobile: $mobile) {
        nodes {
          id
          address
          status
          createdAt
          user {
            id
            name
            mobile
          }
          trackingNumber
          company
          product {
            id
            name
          }
        }

        pageInfo {
          totalCount
          startCursor
          endCursor
        }
      }
    }
  `;

  const IMPORT_TRACKING_INFO = gql`
    mutation importTrackingInfo($logisticsId: ID!, $trackingNumber: String!, $company: String!, $notify: Boolean) {
      importTrackingInfo(
        input: { logisticsId: $logisticsId, trackingNumber: $trackingNumber, company: $company, notify: $notify }
      ) {
        id
      }
    }
  `;
  const BATCH_IMPORT_TRACKING_INFO = gql`
    mutation batchImportTrackingInfo($trackingList: [TrackingInfoInput]) {
      batchImportTrackingInfo(list: $trackingList)
    }
  `;

  const EXPORT_LOGISTICS = gql`
    query logisticses($status: Int) {
      logisticses(status: $status) {
        id
        orderId
        user {
          id
          name
          enrollments {
            id
            source
            sourceId
            group {
              id
              name
              teacher {
                id
                name
              }
            }
          }
        }
        product {
          id
          name
        }
        createdAt
        address
        trackingNumber
        company
      }
    }
  `;

  const handleOk = () => {
    setVisible(false);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const showModal = id => {
    setLogisticsId(id);
    setVisible(true);
  };

  const handleImportOk = () => {
    setImportVisible(false);
  };

  const handleImportCancel = () => {
    setImportVisible(false);
  };

  const showImportModal = () => {
    setImportVisible(true);
  };

  const onSubmit = e => {
    setVariables({
      mobile,
      take: COUNT_PER_PAGE,
      skip: 0,
    });

    setCurrentPage(1);
    e.preventDefault();
  };

  const exportExcel = async () => {
    const response = await client.query<{ logisticses: Logistics[] }>({
      query: EXPORT_LOGISTICS,
      variables: {
        status: LogisticsStasus.AWAITING_DELIVERY,
      },
    });
    const logisticsData = response.data.logisticses
      .filter(logistics => notEmpty(logistics.address))
      .map(logistics => {
        const { id, product, address, createdAt, user, orderId } = logistics;
        const { id: userId, enrollments } = user;

        const enrollment = enrollments.find(
          enrollment => enrollment.source === EnrollmentSource.ORDER && enrollment.sourceId === orderId,
        );

        const [province = '', city = '', detail = '', consignee = '', mobile = ''] = address.split('/');
        return {
          id,
          userId,
          mobile,
          consignee,
          groupName: enrollment && enrollment.group && enrollment.group.name,
          teacherName: enrollment && enrollment.group && enrollment.group.teacher.name,
          createdAt: moment(createdAt).utcOffset(8).format('lll'),
          name: product.name,
          address: `${province}${city}${detail}`,
          trackingNumber: logistics.trackingNumber,
          company: logistics.company,
          notify: true,
        };
      });

    const workbook = xlsx.utils.book_new();
    const sheet1 = xlsx.utils.json_to_sheet(logisticsData);
    xlsx.utils.book_append_sheet(workbook, sheet1);
    xlsx.writeFile(workbook, 'logisticses.xlsx');
  };
  const uploadProps = () => {
    const uploadProps = {
      beforeUpload: (file: UploadFile | Blob) => {
        const oneFile = file as UploadFile;
        if (oneFile.status !== 'removed') {
          const fileList = [oneFile];
          setFileList(fileList);

          const reader = new FileReader();
          const blob = file as Blob;
          reader.readAsBinaryString(blob);
          reader.onload = (event: any) => {
            const data = event.target.result;
            const workbook = xlsx.read(data, {
              type: 'binary',
            });
            const sheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
            if (!sheetName) {
              return;
            }
            const trackingObjList: {
              id: number;
              trackingNumber: string;
              company: string;
              notify: boolean;
            }[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]) || [];
            setTrackingList(
              trackingObjList.map(tracking => {
                return {
                  logisticsId: tracking.id,
                  trackingNumber: tracking.trackingNumber,
                  company: tracking.company,
                  notify: tracking.notify,
                };
              }),
            );
          };
        }
        return false;
      },
      onRemove: () => {
        setFileList([]);
        setTrackingList([]);
      },
    };

    return uploadProps;
  };
  const logisticses = () => (
    <Query<{ logisticsesConnection: { nodes: Logistics[]; pageInfo: PageInfo } }>
      query={GAT_LOGISTICS}
      variables={variables}
    >
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return `Error! ${error}`;
        if (!data) {
          // @ts-ignore
          return <Empty />;
        }
        const { logisticsesConnection } = data;
        return (
          <>
            <Card>
              <Form onSubmit={onSubmit}>
                <Row gutter={24}>
                  <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                    <FormItem label={`用户手机号`}>
                      <Input
                        placeholder="请输入用户手机号"
                        allowClear
                        value={mobile}
                        onChange={e => {
                          setMobile(e.currentTarget.value);
                        }}
                      />
                    </FormItem>
                  </Col>
                </Row>
                <Row type="flex" justify="end">
                  <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                    搜索
                  </Button>
                  <Button
                    icon="download"
                    style={{ marginRight: 8 }}
                    onClick={async () => {
                      await exportExcel();
                    }}
                  >
                    导出
                  </Button>
                  <Mutation
                    mutation={BATCH_IMPORT_TRACKING_INFO}
                    variables={{ trackingList }}
                    refetchQueries={[
                      {
                        variables,
                        query: GAT_LOGISTICS,
                      },
                    ]}
                  >
                    {(batchImportTrackingInfo, { loading, error }) => {
                      if (error) {
                        message.error('导入失败');
                      }
                      return (
                        <>
                          <Button style={{ marginRight: 8 }} onClick={() => showImportModal()}>
                            发货
                          </Button>
                          <Modal
                            title="物流信息"
                            visible={importVisible}
                            onOk={async () => {
                              if (!trackingList.length) {
                                return;
                              }
                              await batchImportTrackingInfo();
                              handleImportOk();
                              message.success('导入成功');
                              return;
                            }}
                            onCancel={handleImportCancel}
                          >
                            <Upload {...uploadProps()} accept=".xls, .xlsx" fileList={fileList} multiple={false}>
                              <Button>
                                <Icon type="upload" /> 选择文件
                              </Button>
                            </Upload>
                            <Table
                              pagination={false}
                              scroll={{ y: 200 }}
                              dataSource={trackingList}
                              rowKey={row => `${row.logisticsId}`}
                            >
                              <Table.Column key="logisticsId" dataIndex="logisticsId" title="id" />
                              <Table.Column key="trackingNumber" dataIndex="trackingNumber" title="运单号" />
                              <Table.Column key="company" dataIndex="company" title="物流公司" />
                              <Table.Column
                                key="notify"
                                dataIndex="notify"
                                title="通知"
                                render={notify => (notify ? '是' : '否')}
                              />
                            </Table>
                          </Modal>
                        </>
                      );
                    }}
                  </Mutation>
                </Row>
              </Form>
            </Card>
            <Table
              dataSource={logisticsesConnection.nodes}
              pagination={false}
              rowKey={row => `${row.id}`}
              footer={() => (
                <Pagination
                  style={{ float: 'right', marginBottom: 16 }}
                  total={logisticsesConnection.pageInfo.totalCount}
                  pageSize={variables.take}
                  current={currentPage}
                  onChange={nextPage => {
                    const pageSkip = (Math.abs(nextPage - currentPage) - 1) * COUNT_PER_PAGE;

                    if (nextPage > currentPage) {
                      setVariables({
                        skip: pageSkip,
                        take: COUNT_PER_PAGE,
                        after: logisticsesConnection.pageInfo.endCursor,
                      });
                    }
                    if (nextPage < currentPage) {
                      setVariables({
                        skip: pageSkip,
                        take: COUNT_PER_PAGE,
                        before: logisticsesConnection.pageInfo.endCursor,
                      });
                    }
                    setCurrentPage(nextPage);
                  }}
                />
              )}
            >
              <Table.Column
                key="user.id"
                dataIndex="user"
                title="用户昵称"
                render={user => {
                  return <Link to={`/user/${user.id}`}>{user.name}</Link>;
                }}
              />
              <Table.Column key="user.mobile" dataIndex="user.mobile" title="手机号" />
              <Table.Column key="product.name" dataIndex="product.name" title="物品" />
              <Table.Column
                key="createdAt"
                dataIndex="createdAt"
                render={createdAt => {
                  return moment(createdAt).utcOffset(8).format('lll');
                }}
                title="创建时间"
              />
              <Table.Column key="address" dataIndex="address" title="用户地址" />
              <Table.Column key="company" dataIndex="company" title="快递公司" />
              <Table.Column key="trackingNumber" dataIndex="trackingNumber" title="物流单号" />
              <Table.Column
                key="operating"
                dataIndex="id"
                title="操作"
                render={(id, record: { id: number; address: string; status: LogisticsStasus }) => {
                  switch (record.status) {
                    case LogisticsStasus.SHIPPED:
                      return '已发货';
                    case LogisticsStasus.CANCELED:
                      return '已取消';
                    case LogisticsStasus.RETURNED:
                      return '已退回';
                    case LogisticsStasus.AWAITING_DELIVERY: {
                      return record.address ? <Button onClick={() => showModal(id)}>发货</Button> : '';
                    }
                    default:
                      return '';
                  }
                }}
              />
            </Table>
            <Mutation
              mutation={IMPORT_TRACKING_INFO}
              variables={{ company, trackingNumber, logisticsId, notify }}
              refetchQueries={[
                {
                  variables,
                  query: GAT_LOGISTICS,
                },
              ]}
            >
              {(importTrackingInfo, { loading, error }) => {
                if (error) {
                  message.error('发货失败');
                }
                return (
                  <Modal
                    title="物流信息"
                    visible={visible}
                    onOk={async () => {
                      if (!company) {
                        return;
                      }
                      if (!trackingNumber) {
                        return;
                      }
                      await importTrackingInfo();
                      message.success('发货成功');
                      handleOk();
                      return;
                    }}
                    onCancel={handleCancel}
                  >
                    <Form>
                      <Form.Item label="物流公司">
                        <Input value={company} onChange={e => setCompany(e.target.value)} />
                        {!company && <Alert message="物流公司不能为空" type="error" />}
                      </Form.Item>
                      <Form.Item label="物流单号">
                        <Input value={trackingNumber} onChange={e => setTrackingNumber(e.target.value)} />
                        {!trackingNumber && <Alert message="物流单号不能为空" type="error" />}
                      </Form.Item>
                      <Form.Item label="是否发送信息">
                        <Switch
                          defaultChecked
                          onChange={e => {
                            setNotify(e);
                          }}
                        />
                      </Form.Item>
                    </Form>
                  </Modal>
                );
              }}
            </Mutation>
          </>
        );
      }}
    </Query>
  );

  return (
    <>
      <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
        <Breadcrumb.Item>
          <Link to={`/Home`}>首页</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>物流管理</Breadcrumb.Item>
      </Breadcrumb>
      <Card>{logisticses()}</Card>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/screens/logistics/LogisticsList.tsx